import { Snackbar } from "@mui/joy";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";

import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import { sendPasswordResetEmail } from "firebase/auth";
import * as React from "react";
import { Link, useNavigate } from "react-router";
import { auth } from "../../config/firebase";

export default function ResetPassword() {
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const [values, setValues] = React.useState({
    email: "",
  });
  const [open, setOpen] = React.useState({
    open: false,
    message: "Request was successful, please check your email",
    color: "success",
  });

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleClose = () => {
    setOpen({ ...open, open: false });
  };

  const reset = (event) => {
    event.preventDefault();
    setLoading(true);

    sendPasswordResetEmail(auth, values.email)
      .then(() => {
        setOpen({ ...open, open: true });
        setLoading(false);
      })
      .catch((error) => {
        const errorMessage = error.message;
        setLoading(false);
        setOpen({
          ...open,
          open: true,
          message: errorMessage,
          color: "warning",
        });
      });
  };

  return (
    <Box
      component="main"
      sx={{
        my: 5,
        py: 2,
        pb: 5,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: 400,
        maxWidth: "100%",
        mx: "auto",
        borderRadius: "sm",
        "& form": {
          display: "flex",
          flexDirection: "column",
          gap: 2,
        },
        [`& .MuiFormLabel-asterisk`]: {
          visibility: "hidden",
        },
      }}
    >
      <Stack sx={{ gap: 1 }}>
        <Typography component="h1" level="h3">
          Reset password
        </Typography>
      </Stack>

      <Divider
        sx={(theme) => ({
          [theme.getColorSchemeSelector("light")]: {
            color: { xs: "#FFF", md: "text.tertiary" },
          },
        })}
      ></Divider>
      <Stack sx={{ gap: 4, mt: 2 }}>
        <form onSubmit={reset}>
          <FormControl size="lg" required>
            <FormLabel>Email</FormLabel>
            <Input onChange={handleChange} type="email" name="email" required />
          </FormControl>

          <Stack sx={{ gap: 4, mt: 2 }}>
            <Button loading={loading} type="submit" fullWidth>
              Reset password
            </Button>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Link
                to={"/auth/login"}
                style={{ textDecoration: "none", color: "#0c6bcc" }}
              >
                Sign in
              </Link>
            </Box>
          </Stack>
        </form>
      </Stack>
      <Snackbar
        color={open.color}
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open.open}
        onClose={handleClose}
      >
        {open.message}
      </Snackbar>
    </Box>
  );
}
